import { ChevronDown } from "lucide-react";
import { useState } from "react";

type Item = { readonly q: string; readonly a: string };

/**
 * Аккордеон FAQ. Один и тот же на главной, в профиле и внутри статей;
 * открыт максимум один вопрос — иначе экран телефона превращается в простыню.
 */
export function Faq({ items, defaultOpen = null }: { items: readonly Item[]; defaultOpen?: number | null }) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  return (
    <div className="faq">
      {items.map((item, index) => (
        <div key={item.q} className={`faq__item${open === index ? " faq__item--open" : ""}`}>
          <button type="button" className="faq__q" onClick={() => setOpen(open === index ? null : index)}>
            {item.q}
            <ChevronDown size={18} strokeWidth={1.8} aria-hidden />
          </button>
          {open === index && <div className="faq__a">{item.a}</div>}
        </div>
      ))}
    </div>
  );
}
